/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from core/schemas/DocumentEnhancerTypes.yaml
import { ToJsonConfiguration } from '../common/JsonSerializationTypes';
import { AspectRatio } from '../geometry/Geometry';
import { ImageRef } from '../image/image';
/** @hidden */
export const DocumentStraighteningModeValues = ['NONE', 'STRAIGHTEN'];
/**
Configuration for document straightening.
*/
export class DocumentStraighteningParameters {
    /** @param source {@displayType `DeepPartial<DocumentStraighteningParameters>`} */
    constructor(source = {}) {
        /**
          Type of document straightening to apply.
          
          Default is STRAIGHTEN
          */
        this.straighteningMode = 'STRAIGHTEN';
        /**
          By default, aspect ratio of the straightened document is automatically determined based on the detected document corners.
          If the document is significantly deformed, the estimated aspect ratio may be inaccurate.
          In such cases, providing a list of expected aspect ratios may help improve the accuracy of the straightening.
          The closest matching aspect ratio from the list will be used.
          Note, that if for a given paper format you want to support both portrait and landscape orientations, you need to provide both aspect ratios (e.g. 1:√2 and √2:1 for A series papers).
          */
        this.aspectRatios = [];
        if (source.straighteningMode !== undefined) {
            this.straighteningMode = source.straighteningMode;
        }
        if (source.aspectRatios !== undefined) {
            this.aspectRatios = source.aspectRatios.map((it) => {
                return new AspectRatio(it);
            });
        }
    }
    serialize(config = new ToJsonConfiguration()) {
        return {
            straighteningMode: this.straighteningMode,
            aspectRatios: this.aspectRatios.map((it) => {
                return it.serialize(config);
            }),
        };
    }
}
/**
Result of the document straightening.
*/
export class DocumentStraighteningResult {
    /** @param source {@displayType `DeepPartial<DocumentStraighteningResult>`} */
    constructor(source = {}) {
        /**
          The straightened document image. Can be null if no document was detected.
          */
        this.straightenedImage = null;
        this._released = false;
        if (source.straightenedImage !== undefined) {
            this.straightenedImage = source.straightenedImage != null ? ImageRef.from(source.straightenedImage) : null;
        }
    }
    async serialize(config = new ToJsonConfiguration()) {
        return {
            straightenedImage: config.serializeImages
                ? this.straightenedImage != null
                    ? await this.straightenedImage.serialize(config.imageSerializationMode)
                    : null
                : undefined,
        };
    }
    release() {
        if (this._released) {
            return;
        }
        {
            if (this.straightenedImage != null) {
                this.straightenedImage.release();
            }
        }
        this._released = true;
    }
    async encodeImages() {
        if (this.straightenedImage != null) {
            await this.straightenedImage.encodeInPlace();
        }
    }
}
//# sourceMappingURL=DocumentEnhancerTypes.js.map